// /src/components/AnswerButtons.jsx
import React from 'react';
import './AnswerButtons.css'
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css'; // Import KaTeX CSS
import './QuestionBubble.css';

const AnswerButtons = ({ options, onAnswerClick }) => {
  return (
    <div className="answer-buttons">
      {options.map((option, index) => (
        <button
          key={index}
          className="answer-button"
          onClick={() => onAnswerClick(option.match(/^[A-D]/)?.[0] || '')}
        >
                <ReactMarkdown 
                  remarkPlugins={[remarkGfm, remarkMath]}
                  rehypePlugins={[rehypeKatex]}
                  className="markdown-content"
                >
                  {option}
                </ReactMarkdown>
        </button>
      ))}
    </div>
  );
};

export default AnswerButtons;